import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { SlideToConfirm } from "@/components/ui/slide-to-confirm"
import type { SynthesisSessionSummary } from "../../domain/entities/synthesis-session"

type Props = {
  target: SynthesisSessionSummary | null
  onClose: () => void
  onConfirm: (id: string) => void
  isPending: boolean
}

export const DeleteSessionDialog = ({
  target,
  onClose,
  onConfirm,
  isPending,
}: Props) => (
  <Dialog open={!!target} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Delete conversation</DialogTitle>
      </DialogHeader>

      <p className="text-sm text-muted-foreground">
        Permanently delete{" "}
        <span className="font-medium text-foreground">{target?.title}</span>?
      </p>

      <SlideToConfirm
        label={isPending ? "Deleting…" : "Slide to confirm"}
        onConfirm={() => target && onConfirm(target.id)}
        className="mt-2"
        isDanger={true}
      />
    </DialogContent>
  </Dialog>
)
